import { render } from "./search_std.vue?vue&type=template&id=2590f053"
import script from "./search_std.vue?vue&type=script&lang=js"
export * from "./search_std.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__